import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { TipoLancamento } from '@models/tipo-lancamento';
import { TipoLancamentoApiService } from '@services/tipo-lancamento-api.service';


@Injectable()
export class CadastroLoteLancamentosResolver implements Resolve<TipoLancamento[]> {

  constructor(
    private tipoLancamentoApiService: TipoLancamentoApiService,
  ) { }

  resolve(router: ActivatedRouteSnapshot): Observable<TipoLancamento[]> {
    const tiposLancamento: Observable<TipoLancamento[]> = this.tipoLancamentoApiService.getTiposLancamento();

    return zip(tiposLancamento).pipe(
      map((values) => {
        return values[0];
      })
    );
  }
}